export function resolveAuthError(t, { page, errorCode, fallbackMessage } = {}) {
  /**
   * Mapeo de códigos estables del backend a claves i18n del frontend.
   *
   * Regla:
   * - El backend decide el tipo de error con `errorCode`
   * - El frontend decide cómo mostrarlo en el idioma actual
   */
  const ERROR_KEY_MAP = {
    register: {
      AUTH_MISSING_EMAIL: "register-error-missing-email",
      AUTH_MISSING_PASSWORD: "register-error-missing-password",
      AUTH_INVALID_EMAIL_FORMAT: "register-error-invalid-email-format",
      AUTH_WEAK_PASSWORD: "register-error-weak-password",
      AUTH_DUPLICATE_EMAIL: "register-error-duplicate-email",
      AUTH_DUPLICATE_USERNAME: "register-error-duplicate-username",
      AUTH_DUPLICATE_EMAIL_OR_USERNAME:
        "register-error-duplicate-email-or-username",
      AUTH_DUPLICATE_USER: "register-error-duplicate-user",
      AUTH_USERNAME_GENERATION_FAILED:
        "register-error-username-generation-failed",
      AUTH_MAIL_MISSING_RECIPIENT: "register-error-mail-failed",
      AUTH_MAIL_MISSING_SUBJECT: "register-error-mail-failed",
      AUTH_SIGNUP_FAILED: "register-error-signup-failed",
      AUTH_CREATE_USER_FAILED: "register-error-signup-failed",
    },

    login: {
      AUTH_INCOMPLETE_LOGIN: "login-error-incomplete-login",
      AUTH_MISSING_EMAIL_OR_USERNAME: "login-error-missing-email-or-username",
      AUTH_MISSING_PASSWORD: "login-error-missing-password",
      AUTH_INVALID_CREDENTIALS: "login-error-invalid-credentials",
      AUTH_ACCOUNT_NOT_VERIFIED: "login-error-account-not-verified",
      AUTH_LOGIN_FAILED: "login-error-login-failed",
    },
  };

  /**
   * Claves genéricas por pantalla.
   * Sirven como red de seguridad si llega un errorCode nuevo
   * todavía no mapeado en el frontend.
   */
  const GENERIC_KEY_BY_PAGE = {
    register: "register-error-generic",
    login: "login-error-generic",
  };

  const safePage = typeof page === "string" ? page.trim().toLowerCase() : "";
  const safeErrorCode =
    typeof errorCode === "string" ? errorCode.trim().toUpperCase() : "";
  const safeFallbackMessage =
    typeof fallbackMessage === "string" ? fallbackMessage.trim() : "";

  const pageMap = ERROR_KEY_MAP[safePage] || null;
  const mappedKey = pageMap && safeErrorCode ? pageMap[safeErrorCode] : null;

  /**
   * 1) Si conocemos el errorCode y su clave i18n, usamos esa.
   */
  if (mappedKey) {
    return t(mappedKey);
  }

  /**
   * 2) Si la pantalla tiene una clave genérica, la usamos.
   * Esto evita mostrar mensajes técnicos del backend cuando
   * llega un errorCode nuevo todavía no contemplado.
   */
  const genericKey = GENERIC_KEY_BY_PAGE[safePage];
  if (genericKey) {
    const translatedGeneric = t(genericKey);

    /**
     * Si i18next no encuentra la clave, suele devolver la propia key.
     * Evitamos mostrar eso al usuario.
     */
    if (translatedGeneric && translatedGeneric !== genericKey) {
      return translatedGeneric;
    }
  }

  /**
   * 3) Como último recurso, devolvemos el mensaje fallback del backend
   * si existe. No es el contrato principal, pero evita dejar la UI vacía.
   */
  if (safeFallbackMessage) {
    return safeFallbackMessage;
  }

  /**
   * 4) Fallback final muy defensivo.
   */
  return "Unexpected error.";
}